export class DateRangeFromTo {
    public fromDate: Date = new Date;
    public toDate: Date = new Date;
}


// WEBPACK FOOTER //
// C:/Users/LIVE02/Documents/SSW/ThanhBuoi/TBE_CRM/src/app/view-model/dateRangeFromTo.viewModel.ts